import { render, staticRenderFns } from "./LsMessage.vue?vue&type=template&id=1670cddd&scoped=true&"
import script from "./LsMessage.vue?vue&type=script&lang=js&"
export * from "./LsMessage.vue?vue&type=script&lang=js&"
import style0 from "./LsMessage.vue?vue&type=style&index=0&id=1670cddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670cddd",
  null
  
)

export default component.exports